import { lazy } from 'react';

export const userDashboardModalComponentByType = {
  INFORMATION_REQUIRED: lazy(() =>
    import('./InformationRequired/InformationRequiredModalContainer').then(
      (module) => ({ default: module.InformationRequiredModalContainer }),
    ),
  ),
  NOTIFICATION_PREFERENCES: lazy(() =>
    import('./NotificationPreferences/NotificationPreferencesModalContainer').then(
      (module) => ({ default: module.NotificationPreferencesModalContainer }),
    ),
  ),
  DELETE_ACCOUNT: lazy(() =>
    import('./DeleteAccount/DeleteAccountModalContainer').then((module) => ({
      default: module.DeleteAccountModalContainer,
    })),
  ),
  ADD_EDIT_WORK_HISTORY_JOB: lazy(() =>
    import('./AddEditWorkHistoryJob/AddEditWorkHistoryJobModalContainer').then(
      (module) => ({ default: module.AddEditWorkHistoryJobModalContainer }),
    ),
  ),
  ADD_EDIT_EDUCATION_HISTORY: lazy(() =>
    import('./AddEditEducationHistory/AddEditEducationHistoryModalContainer').then(
      (module) => ({ default: module.AddEditEducationHistoryModalContainer }),
    ),
  ),
  DELETE_WORK_HISTORY_JOB: lazy(() =>
    import('./DeleteWorkHistoryJob/DeleteWorkHistoryJobModalContainer').then(
      (module) => ({ default: module.DeleteWorkHistoryJobModalContainer }),
    ),
  ),
  DELETE_EDUCATION_HISTORY: lazy(() =>
    import('./DeleteEducationHistory/DeleteEducationHistoryModalContainer').then(
      (module) => ({ default: module.DeleteEducationHistoryModalContainer }),
    ),
  ),
  INTAKE_INTENTS: lazy(() =>
    import('./IntakeIntents/UserDashboardIntakeIntentsModal').then(
      (module) => ({ default: module.UserDashboardIntakeIntentsModal }),
    ),
  ),
  CURATE_SEARCH: lazy(() =>
    import('#/modules/userDashboard/curateSearch/container/UserDashboardCurateSearchModalContainer').then(
      (module) => ({ default: module.UserDashboardCurateSearchModalContainer }),
    ),
  ),
  RESUME_RECOMMENDER_ONBOARDING: lazy(() =>
    import('#/modules/userDashboard/resumeRecommender/ResumeRecommenderModal').then(
      (module) => ({ default: module.ResumeRecommenderModal }),
    ),
  ),
  PROFILE_WIZARD: lazy(() =>
    import('#/modules/userDashboard/profile/containers/modals/Wizard/UserDashboardProfileWizardModalContainer').then(
      (module) => ({
        default: module.UserDashboardProfileWizardModalContainer,
      }),
    ),
  ),
  EDIT_SAVED_SEARCH: lazy(() =>
    import('./EditSavedSearch/EditSavedSearchModalContainer').then(
      (module) => ({ default: module.EditSavedSearchModalContainer }),
    ),
  ),
  FIND_ORG: lazy(() =>
    import('./FindOrganization/FindOrganizationModal').then((module) => ({
      default: module.FindOrganizationModal,
    })),
  ),
} as const satisfies Record<string, unknown>;
